import {
  AddressValidatedAddressJsonldAddressRead,
  AddressValidatedJsonldAddressValidatedPostWrite,
  AddressValidatedJsonldAddressValidatedRead,
} from '@/api/generated';
import { useCreateAddress } from 'hooks/queries/address';

type Props = {
  callback?: (v: AddressValidatedAddressJsonldAddressRead) => void;
};

const useAddressCreateModal = ({ callback }: Props) => {
  const { createAddress, validateAddress } = useCreateAddress();

  const handleValidateAddress = async ({
    values,
    countryCode,
    zipCode,
  }: {
    values: string;
    countryCode: string;
    zipCode: string;
  }): Promise<AddressValidatedJsonldAddressValidatedRead> =>
    (await validateAddress.mutateAsync({ values, countryCode, zipCode })).data;

  const handleCreateAddress = async (data: AddressValidatedJsonldAddressValidatedPostWrite, responseId: string) => {
    const result = await createAddress.mutateAsync({ data, responseId });
    if (callback) {
      callback(result.data);
    }

    return result;
  };

  return { handleCreateAddress, handleValidateAddress, validationResult: validateAddress.data };
};

export default useAddressCreateModal;
